import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import {
	INSTANT_SEARCH_SORT_BY_LEAST_SIGNATURES,
	INSTANT_SEARCH_SORT_BY_MOST_SIGNATURES,
	INSTANT_SEARCH_SORT_BY_NEWEST,
} from 'src/app/pages/search/shared/consts';
import { useInstantSearchIndexName } from 'src/app/pages/search/shared/hooks';

type Result = ModelHookResult<{
	options: ReadonlyArray<{
		label: string;
		value: string;
		subtitle: string;
		trackingContext: string;
	}>;
}>;

export function useSortOptions(): Result {
	const { translate } = useI18n();

	const {
		data: { instantSearchIndexName },
	} = useInstantSearchIndexName();

	const sortByMostSignatures = `${instantSearchIndexName}${INSTANT_SEARCH_SORT_BY_MOST_SIGNATURES}`;
	const sortByLeastSignatures = `${instantSearchIndexName}${INSTANT_SEARCH_SORT_BY_LEAST_SIGNATURES}`;
	const sortByNewest = `${instantSearchIndexName}${INSTANT_SEARCH_SORT_BY_NEWEST}`;

	return {
		data: {
			options: useMemo(
				() => [
					{
						label: translate('corgi.search.sort.options.recent_activity'),
						value: instantSearchIndexName,
						subtitle: translate('corgi.search.sort.options.recent_activity_subtitle'),
						trackingContext: '',
					},
					{
						label: translate('corgi.search.sort.options.most_signatures'),
						value: sortByMostSignatures,
						subtitle: translate('corgi.search.sort.options.most_signatures_subtitle'),
						trackingContext: '',
					},
					{
						label: translate('corgi.search.sort.options.least_signatures'),
						value: sortByLeastSignatures,
						subtitle: translate('corgi.search.sort.options.least_signatures_subtitle'),
						trackingContext: '',
					},
					{
						label: translate('corgi.search.sort.options.newest'),
						value: sortByNewest,
						subtitle: translate('corgi.search.sort.options.newest_subtitle'),
						trackingContext: '',
					},
				],
				[translate, instantSearchIndexName, sortByMostSignatures, sortByLeastSignatures, sortByNewest],
			),
		},
	};
}
